import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HotelPolicyEditDefaultQuery } from "./query";

type Props = { hotelID: string };

export const useHotelPolicyEditQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(HotelPolicyEditDefaultQuery, { variables: { hotelID } });

	return {
		data,
	};
};
